import React from 'react';
import {DatePicker} from "antd";
import {useSelector} from "react-redux";
import UseSetParams from "./UseSetParams";
import {getFilter} from "../../../store/TableRedux/TableRedux";
import locale from "antd/es/date-picker/locale/fa_IR";
import dayjs from "dayjs";

const {RangePicker} = DatePicker;

const DateFilter = ({data}) => {
    const filter = useSelector((state) => state.TableRedux.filter);
    const [handleSetParams,] = UseSetParams(getFilter)
    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter)
    }

    const {filterName, className, showTime = {format: 'HH:mm'}, placeholder = ['شروع زمان', 'اتمام زمان']} = data


    const from = !!filter[filterName[0]] && dayjs(filter[filterName[0]])
    const end = !!filter[filterName[1]] && dayjs(filter[filterName[1]])


    return (


        <>

            <RangePicker
                value={[from, end]}
                defaultValue={[from, end]}
                locale={{
                    ...locale,
                    lang: {
                        ...locale.lang,
                        ok: "تایید",
                    }
                }}
                className={`${className}`} popupClassName='datePickerBtn'
                showTime={showTime}
                format="YYYY-MM-DD HH:mm"
                placeholder={placeholder}
                onOk={(e) => {

                    funcHandleSetParams([{key: filterName[0], value: e ? e[0] : ''}, {
                        key: filterName[1], value: e ? e[1] : ''
                    }])


                }}

            /></>
    );
};

export default DateFilter;